import Sandbox from './Sandbox.js'
import Vue from 'vue'
import translate from './Translate.js'

export function generateUUID () {
  var d = new Date().getTime()
  if (window.performance && typeof window.performance.now === 'function') {
    d += performance.now() // use high-precision timer if available
  }
  var uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    var r = (d + Math.random() * 16) % 16 | 0
    d = Math.floor(d / 16)
    return (c === 'x' ? r : (r & 0x3 | 0x8)).toString(16)
  })
  return uuid
}

const identificationDeviceName = 'WEB-UUID'

export function saveUUIDToLocalStorage (uuid) {
  localStorage.setItem(identificationDeviceName, uuid)
}

export function getUUIDFromLocalStorage () {
  return localStorage.getItem(identificationDeviceName)
}

export async function getUUIDFromSandBox () {
  let uuid = await Sandbox.getUUIDFromSandbox().catch((error) => {
    console.log('get uuid from sand box.', error)
    return ''
  })
  console.log('uuid', uuid)
  return uuid
}

async function getDeviceId () {
  // get uuid from localStorage.
  let deviceId = getUUIDFromLocalStorage()
  if (deviceId) {
    return deviceId
  }
  // get uuid from SandBox.
  deviceId = await getUUIDFromSandBox()
  if (!deviceId) {
    // local not exist uuid. generate uuid.
    deviceId = generateUUID()
  }
  // save uuid to local Storage.
  saveUUIDToLocalStorage(deviceId)
  return deviceId
}

export async function getDeviceInfo () {
  let deviceInfo = {
    'deviceId': null,
    'deviceName': null
  }
  deviceInfo.deviceName = getSystemName()
  deviceInfo.deviceId = await getDeviceId()
  return deviceInfo
}

function checkSystemISPC (userAgent) {
  if (userAgent.indexOf('electron') > -1) {
    return true
  }
  return false
}

function getSystemName () {
  let systemName
  let userAgent = navigator.userAgent.toLowerCase()
  if (!userAgent) {
    return 'web'
  }

  if (checkSystemISPC(userAgent)) {
    systemName = getOSVersion(userAgent) + ' ' + 'PC'
  } else {
    systemName = getOSVersion(userAgent) + ' ' + getBrowerName(userAgent)
  }
  return systemName
}

function getOSVersion (userAgent) {
  let OSVersion
  if (userAgent.indexOf('win') > -1) {
    if (userAgent.indexOf('windows nt 5.0') > -1) {
      OSVersion = 'Windows 2000'
    } else if (userAgent.indexOf('windows nt 5.1') > -1 || userAgent.indexOf('windows nt 5.2') > -1) {
      OSVersion = 'Windows XP'
    } else if (userAgent.indexOf('windows nt 6.0') > -1) {
      OSVersion = 'Windows Vista'
    } else if (userAgent.indexOf('windows nt 6.1') > -1 || userAgent.indexOf('windows 7') > -1) {
      OSVersion = 'Windows 7'
    } else if (userAgent.indexOf('windows nt 6.2') > -1 || userAgent.indexOf('windows 8') > -1) {
      OSVersion = 'Windows 8'
    } else if (userAgent.indexOf('windows nt 6.3') > -1) {
      OSVersion = 'Windows 8.1'
    } else if (userAgent.indexOf('windows nt 6.2') > -1 || userAgent.indexOf('windows nt 10.0') > -1) {
      OSVersion = 'Windows 10'
    } else {
      OSVersion = 'Unknown'
    }
  } else if (userAgent.indexOf('mac') > -1) {
    OSVersion = 'Mac'
  } else if (userAgent.indexOf('x11') > -1 || userAgent.indexOf('unix') > -1 || userAgent.indexOf('sunname') > -1 || userAgent.indexOf('bsd') > -1) {
    OSVersion = 'Unix'
  } else if (userAgent.indexOf('linux') > -1) {
    if (userAgent.indexOf('android') > -1) {
      OSVersion = 'Android'
    } else {
      OSVersion = 'Linux'
    }
  } else {
    OSVersion = 'Unknown'
  }
  return OSVersion
}

function getBrowerName (userAgent) {
  // safari也提供了专门的判定方式
  let systemType = System.isIE ? 'IE' : window.opera || (userAgent.indexOf('opr') > 0) ? 'Opera' : (userAgent.indexOf('chrome') > 0) ? 'Chrome' : window.openDatabase ? 'Safari' : (userAgent.indexOf('firefox') > 0) ? 'Firefox' : 'unknow'

  return systemType
}

export function isGrayEnv () {
  let hashParam = window.location.hash.length > 0 ? window.location.hash.substring(3) : ''
  if (!hashParam) {
    return 0
  }
  let vars = {}
  window.location.href.replace(/[?&]+([^=&]+)=([^&]*)/gi,
    function (m, key, value) {
      vars[key] = value
    }
  )
  return vars['isGray'] ? +vars['isGray'] : 0
}

export function setLoginInfo (params) {
  localStorage.removeItem('login_token')
  localStorage.removeItem('login_code')
  if (!params) { return }
  const token = params['pc_token']
  const code = params['code']
  localStorage.setItem('login_token', token)
  localStorage.setItem('login_code', code)
}

export function jumpToMainWeb (isGray) {
  if (!checkVersion()) {
    return
  }
  if (+isGray === 1 && window.VanishPCSDK) {
    window.VanishPCSDK.store.set('user.isGray', true)
  }
  // 测试环境、预发布 直接访问grayscale web address
  if (location.host.startsWith('vanish-testenv') || location.host.startsWith('vanish-pre')) {
    isGray = 1
  }
  switch (+isGray) {
    case 0:
      location.replace('../web/index.html') // release web address.
      break
    case 1:
      location.replace('../grayscale/index.html') // gray web address.
      break
    default:
      location.replace('../web/index.html') // default is release address
  }
}

export function checkVersion () {
  if (location.search.indexOf('?ua=') > -1 && location.search.indexOf('&version=') > -1) {
    let version = location.search.substr((location.search.indexOf('&version=') + 9))
    let [majorVersion, subVersion, stageVersion] = version.split('.')
    console.log('current Version', majorVersion, subVersion, stageVersion)
    // 2.0以前版本，提示版本太低无法使用
    if (majorVersion < '2') {
      Vue.prototype.$message({
        showClose: true,
        message: translate('Low version notice'),
        type: 'error',
        duration: 0
      })
      return false
    }
  }
  return true
}



// WEBPACK FOOTER //
// ./src/new-login-2018/common/utils.js